import { Heart, Award, Crown, Gem } from "lucide-react";

export const DONOR_TIERS = {
  supporter: { label: "Supporter", color: "#FF2A5F", icon: Heart },
  patron: { label: "Patron", color: "#00E5FF", icon: Gem },
  champion: { label: "Champion", color: "#C084FC", icon: Award },
  legend: { label: "Legend", color: "#FFB020", icon: Crown },
};

export const DonorBadge = ({ tier, size = 14, className = "", testId }) => {
  const t = DONOR_TIERS[tier];
  if (!t) return null;
  const Icon = t.icon;
  return (
    <span
      data-testid={testId || `donor-badge-${tier}`}
      title={`${t.label} — supports KinkVault`}
      aria-label={`${t.label} supporter`}
      className={`inline-flex shrink-0 align-middle ${className}`}
    >
      <Icon size={size} style={{ color: t.color }} fill={t.color} strokeWidth={1.8} />
    </span>
  );
};
